/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#map[_ngcontent-%COMP%]{width:100%;height:367px;margin-bottom:36px}.main-container[_ngcontent-%COMP%]{margin-top:16px;padding:10px;text-align:right}@media (max-width:768px){#map[_ngcontent-%COMP%]{height:calc(100vh - 170px)}}"];
export { styles as styles };
